// This file is auto-generated by Velocious. Do not edit it manually — any changes
// will be overwritten the next time it is generated. Run `velocious generate:frontend-models` to regenerate.
import FrontendModelBase from "velocious/build/src/frontend-models/base.js"

/**
 * Frontend model resource config.
 * @typedef {import("velocious/build/src/frontend-models/base.js").FrontendModelResourceConfig} FrontendModelResourceConfig
 */
/**
 * Fallback attribute value type for generated fields without narrower metadata.
 * @typedef {import("velocious/build/src/frontend-models/base.js").FrontendModelAttributeValue} FrontendModelAttributeValue
 */

/**
 * WebhookSubscriptionAttributes type.
 * @typedef {object} WebhookSubscriptionAttributes
 * @property {boolean} active - Attribute value.
 * @property {Date | null} createdAt - Attribute value.
 * @property {string} createdByUserId - Attribute value.
 * @property {string | null} eventsJson - Attribute value.
 * @property {string} id - Attribute value.
 * @property {Date | null} lastDeliveredAt - Attribute value.
 * @property {string | null} lastError - Attribute value.
 * @property {string} name - Attribute value.
 * @property {string | null} projectId - Attribute value.
 * @property {Date | null} updatedAt - Attribute value.
 * @property {string} url - Attribute value.
 */
/**
 * Attributes accepted by WebhookSubscriptionCreateAttributes.
 * @typedef {object} WebhookSubscriptionCreateAttributes
 * @property {WebhookSubscriptionAttributes["active"] | null} [active] - Permitted active value.
 * @property {WebhookSubscriptionAttributes["name"] | null} [name] - Permitted name value.
 * @property {WebhookSubscriptionAttributes["url"] | null} [url] - Permitted url value.
 */
/**
 * Attributes accepted by WebhookSubscriptionUpdateAttributes.
 * @typedef {object} WebhookSubscriptionUpdateAttributes
 * @property {WebhookSubscriptionAttributes["active"] | null} [active] - Permitted active value.
 * @property {WebhookSubscriptionAttributes["name"] | null} [name] - Permitted name value.
 * @property {WebhookSubscriptionAttributes["url"] | null} [url] - Permitted url value.
 */
/**
 * Frontend model for WebhookSubscription.
 * @augments {FrontendModelBase<WebhookSubscriptionAttributes, WebhookSubscriptionCreateAttributes, WebhookSubscriptionUpdateAttributes, WebhookSubscriptionAttributes["id"], string>}
 */
class WebhookSubscription extends FrontendModelBase {
  /** @returns {FrontendModelResourceConfig} - Resource config. */
  static resourceConfig() {
    return {
      modelName: "WebhookSubscription",
      attributes: [
        "active",
        "createdAt",
        "createdByUserId",
        "eventsJson",
        "id",
        "lastDeliveredAt",
        "lastError",
        "name",
        "projectId",
        "updatedAt",
        "url",
      ],
      collectionCommands: [
        "generate",
      ],
    }
  }

  /** @returns {Record<string, {type: "belongsTo" | "hasOne" | "hasMany", autoload?: boolean}>} - Relationship definitions. */
  static relationshipDefinitions() {
    return {
      createdByUser: {type: "belongsTo"},
      project: {type: "belongsTo"},
    }
  }

  /** @returns {Record<string, string>} - Relationship model class names. */
  static relationshipModelClasses() {
    return {
      createdByUser: "User",
      project: "Project",
    }
  }

  /** @returns {WebhookSubscriptionAttributes["active"]} - Attribute value. */
  active() { return /** @type {WebhookSubscriptionAttributes["active"]} */ (this.readAttribute("active")) }

  /**
   * @param {WebhookSubscriptionAttributes["active"] | null} newValue - New attribute value.
   * @returns {WebhookSubscriptionAttributes["active"] | null} - Assigned value.
   */
  setActive(newValue) { return /** @type {WebhookSubscriptionAttributes["active"] | null} */ (this.setAttribute("active", newValue)) }

  /** @returns {WebhookSubscriptionAttributes["createdAt"]} - Attribute value. */
  createdAt() { return /** @type {WebhookSubscriptionAttributes["createdAt"]} */ (this.readAttribute("createdAt")) }

  /**
   * @param {Date | string | null} newValue - New attribute value.
   * @returns {Date | string | null} - Assigned value.
   */
  setCreatedAt(newValue) { return /** @type {Date | string | null} */ (this.setAttribute("createdAt", newValue)) }

  /** @returns {WebhookSubscriptionAttributes["createdByUserId"]} - Attribute value. */
  createdByUserId() { return /** @type {WebhookSubscriptionAttributes["createdByUserId"]} */ (this.readAttribute("createdByUserId")) }

  /**
   * @param {WebhookSubscriptionAttributes["createdByUserId"] | null} newValue - New attribute value.
   * @returns {WebhookSubscriptionAttributes["createdByUserId"] | null} - Assigned value.
   */
  setCreatedByUserId(newValue) { return /** @type {WebhookSubscriptionAttributes["createdByUserId"] | null} */ (this.setAttribute("createdByUserId", newValue)) }

  /** @returns {WebhookSubscriptionAttributes["eventsJson"]} - Attribute value. */
  eventsJson() { return /** @type {WebhookSubscriptionAttributes["eventsJson"]} */ (this.readAttribute("eventsJson")) }

  /**
   * @param {WebhookSubscriptionAttributes["eventsJson"] | null} newValue - New attribute value.
   * @returns {WebhookSubscriptionAttributes["eventsJson"] | null} - Assigned value.
   */
  setEventsJson(newValue) { return /** @type {WebhookSubscriptionAttributes["eventsJson"] | null} */ (this.setAttribute("eventsJson", newValue)) }

  /** @returns {WebhookSubscriptionAttributes["id"]} - Attribute value. */
  id() { return /** @type {WebhookSubscriptionAttributes["id"]} */ (this.readAttribute("id")) }

  /**
   * @param {WebhookSubscriptionAttributes["id"] | null} newValue - New attribute value.
   * @returns {WebhookSubscriptionAttributes["id"] | null} - Assigned value.
   */
  setId(newValue) { return /** @type {WebhookSubscriptionAttributes["id"] | null} */ (this.setAttribute("id", newValue)) }

  /** @returns {WebhookSubscriptionAttributes["lastDeliveredAt"]} - Attribute value. */
  lastDeliveredAt() { return /** @type {WebhookSubscriptionAttributes["lastDeliveredAt"]} */ (this.readAttribute("lastDeliveredAt")) }

  /**
   * @param {Date | string | null} newValue - New attribute value.
   * @returns {Date | string | null} - Assigned value.
   */
  setLastDeliveredAt(newValue) { return /** @type {Date | string | null} */ (this.setAttribute("lastDeliveredAt", newValue)) }

  /** @returns {WebhookSubscriptionAttributes["lastError"]} - Attribute value. */
  lastError() { return /** @type {WebhookSubscriptionAttributes["lastError"]} */ (this.readAttribute("lastError")) }

  /**
   * @param {WebhookSubscriptionAttributes["lastError"] | null} newValue - New attribute value.
   * @returns {WebhookSubscriptionAttributes["lastError"] | null} - Assigned value.
   */
  setLastError(newValue) { return /** @type {WebhookSubscriptionAttributes["lastError"] | null} */ (this.setAttribute("lastError", newValue)) }

  /** @returns {WebhookSubscriptionAttributes["name"]} - Attribute value. */
  name() { return /** @type {WebhookSubscriptionAttributes["name"]} */ (this.readAttribute("name")) }

  /**
   * @param {WebhookSubscriptionAttributes["name"] | null} newValue - New attribute value.
   * @returns {WebhookSubscriptionAttributes["name"] | null} - Assigned value.
   */
  setName(newValue) { return /** @type {WebhookSubscriptionAttributes["name"] | null} */ (this.setAttribute("name", newValue)) }

  /** @returns {WebhookSubscriptionAttributes["projectId"]} - Attribute value. */
  projectId() { return /** @type {WebhookSubscriptionAttributes["projectId"]} */ (this.readAttribute("projectId")) }

  /**
   * @param {WebhookSubscriptionAttributes["projectId"] | null} newValue - New attribute value.
   * @returns {WebhookSubscriptionAttributes["projectId"] | null} - Assigned value.
   */
  setProjectId(newValue) { return /** @type {WebhookSubscriptionAttributes["projectId"] | null} */ (this.setAttribute("projectId", newValue)) }

  /** @returns {WebhookSubscriptionAttributes["updatedAt"]} - Attribute value. */
  updatedAt() { return /** @type {WebhookSubscriptionAttributes["updatedAt"]} */ (this.readAttribute("updatedAt")) }

  /**
   * @param {Date | string | null} newValue - New attribute value.
   * @returns {Date | string | null} - Assigned value.
   */
  setUpdatedAt(newValue) { return /** @type {Date | string | null} */ (this.setAttribute("updatedAt", newValue)) }

  /** @returns {WebhookSubscriptionAttributes["url"]} - Attribute value. */
  url() { return /** @type {WebhookSubscriptionAttributes["url"]} */ (this.readAttribute("url")) }

  /**
   * @param {WebhookSubscriptionAttributes["url"] | null} newValue - New attribute value.
   * @returns {WebhookSubscriptionAttributes["url"] | null} - Assigned value.
   */
  setUrl(newValue) { return /** @type {WebhookSubscriptionAttributes["url"] | null} */ (this.setAttribute("url", newValue)) }

  /**
   * Runs generate.
   * @param {...FrontendModelAttributeValue} commandArguments - Custom command arguments.
   * @returns {Promise<{secret: string, webhookSubscription: {active: boolean, createdAt: Date | null, createdByUserId: string, events: string[], id: string, lastDeliveredAt: Date | null, lastError: string | null, name: string, projectId: string | null, updatedAt: Date | null, url: string}}>} - Command response.
   */
  static async generate(...commandArguments) {
    return /** @type {{secret: string, webhookSubscription: {active: boolean, createdAt: Date | null, createdByUserId: string, events: string[], id: string, lastDeliveredAt: Date | null, lastError: string | null, name: string, projectId: string | null, updatedAt: Date | null, url: string}}} */ (await this.executeCustomCommand({
      commandName: "generate",
      commandType: "generate",
      payload: WebhookSubscription.normalizeCustomCommandPayloadArguments(commandArguments),
      resourcePath: this.resourcePath()
    }))
  }

  /**
   * Returns createdByUser relationship helper.
   * @returns {import("velocious/build/src/frontend-models/base.js").FrontendModelSingularRelationship<WebhookSubscription, import("./user.js").User, import("./user.js").UserCreateAttributes>} - Relationship helper.
   */
  createdByUserRelationship() { return /** @type {import("velocious/build/src/frontend-models/base.js").FrontendModelSingularRelationship<WebhookSubscription, import("./user.js").User, import("./user.js").UserCreateAttributes>} */ (this.getRelationshipByName("createdByUser")) }

  /**
   * Returns createdByUser.
   * @returns {import("./user.js").User | null} - Loaded related model.
   */
  createdByUser() { return this.createdByUserRelationship().loaded() }

  /**
   * Builds createdByUser.
   * @param {import("./user.js").UserCreateAttributes} [attributes] - Attributes for the new related model.
   * @returns {import("./user.js").User} - Built related model.
   */
  buildCreatedByUser(attributes = {}) { return this.createdByUserRelationship().build(attributes) }

  /**
   * Loads createdByUser.
   * @returns {Promise<import("./user.js").User | null>} - Loaded related model.
   */
  async loadCreatedByUser() { return await this.createdByUserRelationship().load() }

  /**
   * Returns or loads createdByUser.
   * @returns {Promise<import("./user.js").User | null>} - Loaded related model.
   */
  async createdByUserOrLoad() { return await this.createdByUserRelationship().orLoad() }

  /**
   * Sets createdByUser.
   * @param {import("./user.js").User | null} model - Related model.
   * @returns {void}
   */
  setCreatedByUser(model) { this.createdByUserRelationship().setLoaded(model) }

  /**
   * Returns project relationship helper.
   * @returns {import("velocious/build/src/frontend-models/base.js").FrontendModelSingularRelationship<WebhookSubscription, import("./project.js").Project, import("./project.js").ProjectCreateAttributes>} - Relationship helper.
   */
  projectRelationship() { return /** @type {import("velocious/build/src/frontend-models/base.js").FrontendModelSingularRelationship<WebhookSubscription, import("./project.js").Project, import("./project.js").ProjectCreateAttributes>} */ (this.getRelationshipByName("project")) }

  /**
   * Returns project.
   * @returns {import("./project.js").Project | null} - Loaded related model.
   */
  project() { return this.projectRelationship().loaded() }

  /**
   * Builds project.
   * @param {import("./project.js").ProjectCreateAttributes} [attributes] - Attributes for the new related model.
   * @returns {import("./project.js").Project} - Built related model.
   */
  buildProject(attributes = {}) { return this.projectRelationship().build(attributes) }

  /**
   * Loads project.
   * @returns {Promise<import("./project.js").Project | null>} - Loaded related model.
   */
  async loadProject() { return await this.projectRelationship().load() }

  /**
   * Returns or loads project.
   * @returns {Promise<import("./project.js").Project | null>} - Loaded related model.
   */
  async projectOrLoad() { return await this.projectRelationship().orLoad() }

  /**
   * Sets project.
   * @param {import("./project.js").Project | null} model - Related model.
   * @returns {void}
   */
  setProject(model) { this.projectRelationship().setLoaded(model) }

  /**
   * Registers a class-level destroy callback.
   * @overload
   * @param {(payload: {id: string}) => void} callback - Event callback.
   * @param {import("velocious/build/src/frontend-models/base.js").FrontendModelEventOptions} [options] - Destroy event options.
   * @returns {Promise<() => void>} - Unsubscribe callback.
   */
  /**
   * @template {import("velocious/build/src/frontend-models/base.js").FrontendModelClass} T
   * @overload
   * @this {T}
   * @param {(payload: {id: import("velocious/build/src/frontend-models/base.js").FrontendModelEventPrimaryKeyValueFor<InstanceType<T>>}) => void} callback - Event callback.
   * @param {import("velocious/build/src/frontend-models/base.js").FrontendModelEventOptions} [options] - Destroy event options.
   * @returns {Promise<() => void>} - Unsubscribe callback.
   */
  /**
   * Implements class-level destroy callback registration.
   * @param {(payload: {id: never}) => void} callback - Type-erased event callback.
   * @param {import("velocious/build/src/frontend-models/base.js").FrontendModelEventOptions} [options] - Destroy event options.
   * @returns {Promise<() => void>} - Unsubscribe callback.
   */
  static async onDestroy(callback, options = {}) {
    return await this._registerDestroyEventCallback(callback, options)
  }
}

FrontendModelBase.registerModel(WebhookSubscription)

export {WebhookSubscription}

export default WebhookSubscription
